import React, { useState, useMemo } from "react";
import { Modal } from "antd";
import ConsumerImage from "../images/svg/one-insight/Consumer.svg";
import HealthcareImage from "../images/svg/one-insight/Healthcare.svg";
import GovernmentImage from "../images/svg/politics_private.svg";
import ICChecked from "../images/svg/one-insight/ICChecked.svg";
import ICUnCheck from "../images/svg/one-insight/ICUnCheck.svg";
import MainServices from "../services/Main.services";
import { useSelector } from "react-redux";
import { getMainState } from "../store/components/Main.slice";

export const forceDisabled = () => {
  const { username } = MainServices._information;
  const users = ["ovalone01@gmail.com"]

  return users.includes(username?.toLowerCase())
}
export const isHardcodedUser = () => {
  const { username, signedUsergroup = {} } = MainServices._information;
  const { usergroupName = "" } = signedUsergroup
  const [usergroup] = usergroupName.split("~");
  const users = [
    "qrm_bonnie",
    "qrm_rene",
    "qrm_billy",
    "qrm_joey",
    "harsh.lakhani@sqreem.com",
    "ian@sqreem.com",
    "ianchapmanbanks@sqreem.com",
    "i.gasiak@cognitive.com.ua",
    "o.moskalenko@cognitive.com",
    "marcus.imaizumi@sqreem.com",
    "german.palomares@sqreem.com",
    "stephanie.lublinski@sqreem.com",
    "chris.stier@sqreem.com",
    "emiliamedina@pulsarmedia.com.br",
    "ovalone01@gmail.com"
  ]
  const usergroups = [
    "sqreem-developer"
  ]
  const userHardcoded = users && users.includes(username?.toLowerCase());
  const usergroupHardcoded = usergroups && usergroups.includes(usergroup?.toLowerCase());
  return userHardcoded || usergroupHardcoded
}

const OneInsightModal = ({ isVisible, onOk, onCancel }) => {
  const [selectedOption, setSelectedOption] = useState("consumer");
  const { oneInsightPerm } = useSelector(getMainState);

  const handleOptionClick = (optionId) => {
    setSelectedOption(optionId);
  };

  const handleOk = () => {
    onOk(selectedOption);
  };

  const options = useMemo(() => {
    const subApp = [
      {
        id: 1,
        name: "Consumer",
        code: "consumer",
        image: ConsumerImage,
        disabled: forceDisabled() ? true : !oneInsightPerm.includes("consumer")
      },
      {
        id: 2,
        name: "Healthcare",
        code: "healthcare",
        image: HealthcareImage,
        disabled: forceDisabled() ? true : !oneInsightPerm.includes("healthcare")
      },
      {
        id: 3,
        name: "Government",
        code: "government",
        image: GovernmentImage,
        disabled: !(isHardcodedUser() || oneInsightPerm.includes("governmentplaform"))
      }
    ]
    return subApp
  }, [isVisible]);

  console.log(isHardcodedUser());


  return (
    <Modal
      className="primary-modal oi-modal"
      title="One Insight"
      okText="Continue"
      open={isVisible}
      onOk={handleOk}
      centered
      onCancel={onCancel}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div className="oi-modal-list">
        {options.map((option) => (
          <div
            key={option.code}
            className={`
              oi-modal-item 
              ${selectedOption === option.code ? "active" : ""}
              ${option.disabled && "disabled"}  
            `}
            onClick={() => !option.disabled && handleOptionClick(option.code)}
          >
            <img
              src={selectedOption === option.code ? ICChecked : ICUnCheck}
              alt={option.name + " icon"}
              className="oi-modal-item-icon"
            />
            <img
              src={option.image}
              alt={option.name}
              className="oi-modal-item-image"
            />
            <div className="oi-modal-item-name">{option.name}</div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default OneInsightModal;
